import { RangeSlider, type RangeSliderProps } from '@chakra-ui/react'
import { SizeType } from '@/types'
import React from 'react'

interface Props extends RangeSliderProps {
  size?: SizeType,
};

const Component = React.forwardRef((props: Props, ref: React.Ref<any>) => {
  return (
    <RangeSlider ref={ref} { ...props } />
  )
})


export {
  Component as RangeSlider,
  type Props as RangeSliderProps,
}
